import type {FC, PropsWithChildren} from 'react';

import {linkFragmentToHref} from '@/modules/foundation/sanity/link/query';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import {CardLinkListSelection} from '../../components/card-link-list-selection';
import type {LinkCardProps} from '../../components/card-link-list-selection/LinkCard';

import type {CardLinkListSelectionFragmentType} from './query';

type Props = PropsWithChildren & {
	data: CardLinkListSelectionFragmentType;
	fullWidth?: boolean;
	insideToc?: boolean;
};

export const CardLinkListSelectionContainer: FC<Props> = ({data, fullWidth, insideToc}) => {
	const links: KeyedArray<LinkCardProps> = [];

	if (data.links) {
		for (const link of data.links) {
			links.push({
				_key: link._key,
				href: linkFragmentToHref(link),
				title: link.title ?? 'Mangler tittel...',
				description: link.description ?? '',
				icon: link.icon,
			});
		}
	}

	return (
		<CardLinkListSelection
			links={links}
			options={{fullWidth, ...data?.contentBlockOptions}}
			insideToc={insideToc}
		/>
	);
};
